/**
 * Shared types and constants for the TeamPage components.
 *
 * Kept in one place so `TeamPage/index.svelte` and its child components
 * (`Squads`, `Matches`, `Trophies`, …) don't redeclare the same shapes
 * and drift out of sync.
 */

/** Minimal team shape the TeamPage and its children need (from `getTeams`). */
export type Team = {
  id: string;
  code: string;
  name: string;
  slug: string;
};

/** Minimal squad member shape the TeamPage and its children need. */
export type SquadMember = {
  firstName?: string;
  lastName?: string;
  matchName?: string;
  role?: string;
  position?: string;
  shirtNumber?: string | number;
};

/** Player positions used by the Squads layout. */
export type Position = 'Goalkeeper' | 'Defender' | 'Midfielder' | 'Attacker';

/** Known `role` strings from the data source. */
export const ROLE = {
  coach: 'coach',
  assistantCoach: 'assistant coach',
} as const;
